import { Collapse, Grid, IconButton, Typography } from "@mui/material";
import { Fragment, memo, useState } from "react";
import CollapseIcon from "@entrilia/shared/icons/CollapseIcon";
import ExpandIcon from "@entrilia/shared/icons/ExpandIcon";

import type { ChartOfAccountsItem } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  text?: string | number | null;
  name?: string | number | null;
  conditionName: string;
  chartOfAccountItems?: ChartOfAccountsItem[];
}
const FilterItemInner = ({ text, name, conditionName, chartOfAccountItems }: Props) => {
  const [conditionExpanded, setConditionExpanded] = useState(false);

  const subItems =
    conditionName === "AccountCategory"
      ? (chartOfAccountItems || []).filter((item) => item.accountCategory === text)
      : [];

  return (
    <Fragment key={`FilterItem${name}`}>
      <Grid
        container
        sx={(theme) => ({
          width: "100%",
          justifyContent: "space-between",
          "& .MuiSvgIcon-root": {
            color: theme.palette.secondary.light,
          },
        })}
      >
        <Grid container sx={{ alignItems: "center", height: "28px", width: "auto" }}>
          <IconButton
            sx={{ visibility: subItems.length > 0 ? "visible" : "hidden" }}
            onClick={() => setConditionExpanded((prev) => !prev)}
          >
            {conditionExpanded ? <CollapseIcon /> : <ExpandIcon />}
          </IconButton>
        </Grid>
        <Grid
          container
          sx={(theme) => ({
            alignItems: "center",
            height: "28px",
            width: "100%",
            flex: 1,
            color: theme.palette.text.primary,
          })}
        >
          <Grid sx={{ flex: 1 }}>
            <Typography variant="caption">{text?.toString()}</Typography>
          </Grid>
          <Grid sx={{ flex: 1 }}>
            <Typography variant="caption">{name}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Collapse
        orientation="vertical"
        in={conditionExpanded}
        sx={{
          "& .MuiCollapse-wrapperInner": {
            display: "flex",
            flexDirection: "column",
          },
          width: "100%",
        }}
      >
        {subItems.map((item, i) => (
          <Grid
            // eslint-disable-next-line @eslint-react/no-array-index-key
            key={`subitem-${i}`}
            container
            sx={(theme) => ({
              alignItems: "center",
              color: theme.palette.text.secondary,
              paddingLeft: 4.75,
              width: "100%",
              pr: 1,
              flexWrap: "nowrap",
            })}
          >
            <Grid sx={{ flex: 1, wordBreak: "break-word", py: 0.5 }}>
              <Typography variant="caption">{item.accountNo}</Typography>
            </Grid>
            <Grid sx={{ flex: 1, wordBreak: "break-word", py: 0.5 }}>
              <Typography variant="caption">{item.accountName}</Typography>
            </Grid>
          </Grid>
        ))}
      </Collapse>
    </Fragment>
  );
};

const FilterItem = memo(FilterItemInner, (prev, next) => prev.name === next.name && prev.text === next.text);

export default FilterItem;
